class ImageTextSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
  }

  connectedCallback() {
    this.slider = new Swiper(this, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      updateOnWindowResize: true,
      grabCursor: true,
      initialSlide: 0,

      navigation: {
        nextEl: this.querySelector('.image-text-slider__button--next'),
        prevEl: this.querySelector('.image-text-slider__button--prev'),
      },

      scrollbar: {
        el: this.querySelector('.image-text-slider__scrollbar'),
      },

      breakpoints: {
        750: {
          spaceBetween: 0
        }
      },

      on: {
        click() {
          this.slideToLoop(+this.clickedSlide.dataset.swiperSlideIndex);
        },
      },
    })
  }
}

if (!customElements.get('image-text-slider')) {
  customElements.define('image-text-slider', ImageTextSlider);
}